import { render, staticRenderFns } from "./form-device-bar-fields.vue?vue&type=template&id=af9c482e&scoped=true"
import script from "./form-device-bar-fields.vue?vue&type=script&lang=ts"
export * from "./form-device-bar-fields.vue?vue&type=script&lang=ts"
import style0 from "./form-device-bar-fields.vue?vue&type=style&index=0&id=af9c482e&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af9c482e",
  null
  
)

export default component.exports